// const vex = require('vex-js')
// vex.registerPlugin(require('vex-dialog'))
// vex.defaultOptions.className = 'vex-theme-plain'

var dialog = (text, callback = function(){}) => {
    window.vex.dialog.alert({
        message: text,
        callback
    })
}

dialog.confirm = (text, callback, reject = function(){}) => {
    window.vex.dialog.confirm({
        message: text,
        callback: (value) => {
            if (value) {
                callback(value)
            } else {
                reject()
            }
        }
    })
}

dialog.prompt = (text, callback, reject = function(){}) => {
    window.vex.dialog.prompt({
        message: text,
        callback: (value) => {
            if (value) {
                callback(value)
            } else {
                reject()
            }
        }
    })
}

dialog.on = (pr, text) => {
    pr.then(() => {
        windows.vex.dialog.alert(text)
    })
}

export default {
    install(Vue) {
        Vue.prototype.$dialog = dialog;
    }
}





// WEBPACK FOOTER //
// ./src/plugins/dialog.js